import React, { useContext, useState } from 'react'
import { CaretDownIcon, CaretUpIcon, HandbagIcon } from '@phosphor-icons/react'
import { StoreContext } from "@context/StoreContext"
import {formatPrice} from '@utils'

export const Checkout = () => {
    const {checkout} = useContext(StoreContext);
    const emptyCart = checkout?.lines?.edges?.length === 0;
    const [showPriceDetails, setShowPriceDetails] = useState(false)

    
    const handleProceedToCheckout = () => {
        if(process.env.GATSBY_STORE !== "PH") {
            window.location.href = checkout?.checkoutUrl.replace("blackboughswim.com", "checkout.blackboughswim.com");
        } else {
            window.location.href = checkout?.checkoutUrl.replace("blackboughswim.ph", "checkout.blackboughswim.ph");
        }
    }
    

    return (
        !emptyCart  ? (
            <section className={`self-end space-y-4 w-full fixed bottom-0`}>
                <div className={`bg-white`}>
                    <div className="flex justify-end relative mb-2">
                        <div className={`absolute border-t border-gray-400 h-0.5 w-full top-[50%] bottom-[50%] z-0 shadow-[0px_-3px_7px_rgba(0,0,0,0.5)]`}></div>
                        <div className="mr-3 bg-white z-50">
                            {!showPriceDetails ? (
                                <CaretUpIcon
                                    size={28}
                                    weight="light"
                                    className="cursor-pointer border border-gray-400 rounded-sm p-0.5"
                                    onClick={() =>
                                        setShowPriceDetails(!showPriceDetails)
                                    }
                                />
                            ) : (
                                <CaretDownIcon
                                    size={28}
                                    weight="light"
                                    className="cursor-pointer border border-gray-400 rounded-sm p-0.5"
                                    onClick={() =>
                                        setShowPriceDetails(!showPriceDetails)
                                    }
                                />
                            )}
                        </div>
                    </div>
                    <div className="space-y-3 text-[#6D6D6D] px-4">
                        <div className="flex flex-nowrap justify-between">
                            <span className="flex-1 text-tertiary">Subtotal</span>
                            <span className="text-black">
                                {
                                    formatPrice(
                                        checkout?.cost?.subtotalAmount?.currencyCode,
                                        checkout?.cost?.subtotalAmount?.amount
                                    )
                                }
                            </span>
                        </div>
                        
                        
                        {
                            showPriceDetails && (
                                <>
                                    <div className="flex flex-nowrap justify-between">
                                        <span className="flex-1 text-tertiary">Shipping Estimate</span>
                                        <span className="text-black">Next Step</span>
                                    </div>

                                    <div className="flex flex-nowrap justify-between">
                                        <span className="flex-1 text-tertiary">Taxes</span>
                                        <span className="text-black">
                                            {
                                                formatPrice(
                                                    checkout?.cost?.totalTaxAmount ? checkout?.cost?.totalTaxAmount?.currencyCode : "PHP",
                                                    checkout?.cost?.totalTaxAmount ? checkout?.cost?.totalTaxAmount?.amount : 0
                                                )
                                            }
                                        </span>
                                    </div>
                                </>
                            )
                        }
                    </div>

                    <div className="p-4">
                        <button className="btn-primary flex items-center justify-center p-3 w-full" onClick={() => handleProceedToCheckout()} aria-label='Proceed to Checkout'>
                            <HandbagIcon size={20} weight="light" className="mr-4" />
                            Proceed to Checkout
                        </button>
                    </div>
                </div>
            </section>
        ) : null
    )
}



export default Checkout;